import { render } from "./CSVIcon.vue?vue&type=template&id=6ecd9bb4"
import script from "./CSVIcon.vue?vue&type=script&lang=js"
export * from "./CSVIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__